import axios from '../axios';
const END_POINT = '/accounting-articles';

const patientPayment = (payment) => axios.post(`${END_POINT}/patient-payment`, payment);
const patientExcessReceived = (excess) => axios.post(`${END_POINT}/excess-received`, excess);
const getAllPayments = (getTheAmountAccountingDocumentId) => axios.get(`${END_POINT}/get-all-payments/${getTheAmountAccountingDocumentId}`);
const getAllExcess = (excessReceivedAccountingDocumentId) => axios.get(`${END_POINT}/get-all-excess-received/${excessReceivedAccountingDocumentId}`);
const identificationReceivedPatient = (payment) => axios.post(`${END_POINT}/identification-received-patient`, payment);
const getByDocumentId = (documentId) => axios.post(`${END_POINT}/get-by-document-id/${documentId}`);
const removeAPayment = (relatedArticles, documentId) => axios.delete(`${END_POINT}/remove-payment/${relatedArticles}/${documentId}`);
const removeAnExcess = (relatedArticles, documentId) => axios.delete(`${END_POINT}/remove-excess-received/${relatedArticles}/${documentId}`);
const removeIdentificationReturn = (identificationReturnFromServicesRenderedDocumentId) => axios.delete(`${END_POINT}/remove-identification-return/${identificationReturnFromServicesRenderedDocumentId}`);
const identificationReturnForExcess = (payload) => axios.post(`${END_POINT}/identification-return-for-excess-received`, payload);
const identificationReturn = (payload) => axios.post(`${END_POINT}/identification-return`, payload);
const getAllReturnsForReception = (identificationReturnFromServicesRenderedDocumentId) => axios.get(`${END_POINT}/get-all-returns/${identificationReturnFromServicesRenderedDocumentId}`);
const returnFromServicesRendered = (payload) => axios.post(`${END_POINT}/return-from-services-rendered`, payload);
const updatePayment = (payload) => axios.patch(`${END_POINT}/update-payment`, payload);

export {
    patientPayment,
    identificationReceivedPatient,
    getByDocumentId,
    getAllPayments,
    removeAPayment,
    patientExcessReceived,
    getAllExcess,
    removeAnExcess,
    identificationReturnForExcess,
    getAllReturnsForReception,
    returnFromServicesRendered,
    identificationReturn,
    removeIdentificationReturn,
    updatePayment
}